import { render, staticRenderFns } from "./PLoading.vue?vue&type=template&id=5c8e737c&scoped=true&"
import script from "./PLoading.vue?vue&type=script&lang=ts&"
export * from "./PLoading.vue?vue&type=script&lang=ts&"
import style0 from "./PLoading.vue?vue&type=style&index=0&id=5c8e737c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8e737c",
  null
  
)

export default component.exports